import React from "react";
import { shape } from "../../../../utils/map/shapes";

export const Caption = ({legendsValues, selectedItem, addressInfos, isOpen, onClose}) => {
    return (
        <div id="modal-legend" aria-hidden="true" aria-modal='true' className={`modal fade ${isOpen ? 'show' : ''}`}>
            <div className="modal-content">
                <div className="modal-header">
                    <p>Informations</p>
                    <button type="button" aria-label="Fermer" onClick={onClose} >&#xD7;</button>
                </div>
                <div className="modal-body">
                    <hr />
                    {selectedItem && legendsValues && legendsValues.map(lv => 
                        <div>
                            <h2>{lv.label}</h2>
                            {lv.legends.map(v =>
                                <div className="legend-item">
                                    <span className="shape-legend" dangerouslySetInnerHTML={{ __html: shape(v.shape, v.color)}}></span>
                                    <p>{v.label}</p>
                                </div>
                            )}
                        </div>
                    )}
                    {addressInfos &&
                        <div>
                            <h2>{addressInfos.com.libelle}</h2>
                            <div>
                                <div className="legend-item">
                                    <span className="shape-legend" dangerouslySetInnerHTML={{ __html: shape('dotted', '#000')}}></span>
                                    <p>Contour de la ville</p>
                                </div>
                                {addressInfos.address && addressInfos.address.label &&
                                    <div className="legend-item">
                                        <span className="shape-legend" dangerouslySetInnerHTML={{ __html: shape('marker', '#000')}}></span>
                                        <p>{addressInfos.address.label}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}